import * as Yup from "yup";

export const createWithdrawValidaion = Yup.object().shape({
  money: Yup.number()
    .typeError("Bạn cần nhập số")
    .min(500000, "Bạn cần rút tối thiểu 500.000đ")
    .required("Số tiền không được để trống"),
  bank_name: Yup.string().required(
    "Thông tin ngân hàng nhận không được để trống"
  ),
  bank_number: Yup.string().required(
    "Thông tin ngân hàng nhận không được để trống"
  ),
  bank_owner: Yup.string().required(
    "Thông tin ngân hàng nhận không được để trống"
  ),
});
